/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductFromJSON, FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductToJSON, } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProduct';
/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFront interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFront(value) {
    if (!('Products' in value) || value['Products'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontFromJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Products': (json['Products'].map(FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductFromJSON)),
    };
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontToJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontToJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Products': (value['Products'].map(FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductToJSON)),
    };
}
//# sourceMappingURL=FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFront.js.map